const Loader = () => {
  return (
    <div className="fixed top-0 bottom-0 z-[50] bg-[#00000033]  right-0 left-0 h-screen w-screen flex items-center justify-center">
      <span className="loader opacity-100"></span>
    </div>
  );
};

export default Loader;
